import { Component, useEffect } from 'react';
import Lenis from 'lenis';
import Header from './components/Header';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import Services from './components/Services';
import InspirationGallery from './components/InspirationGallery';
import Emotional from './components/Emotional';
import WhyKindstone from './components/WhyKindstone';
import HowItWorks from './components/HowItWorks';
import ServiceAreas from './components/ServiceAreas';
import FAQ from './components/FAQ';
import QuoteForm from './components/QuoteForm';
import Footer from './components/Footer';
import StickyMobileCTA from './components/StickyMobileCTA';
import MetaPixelConsent from './components/MetaPixelConsent';
import './App.css';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="grid min-h-screen place-items-center bg-white p-8 text-center">
          <div>
            <p className="text-2xl font-extrabold text-navy">KINDSTONE Cleaning Services</p>
            <p className="mt-3 text-charcoal">
              Something went wrong. Please refresh the page, text (407) 794-0555, or email contact@kindstonecleaning.com.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const App = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-white font-sans text-charcoal">
        <Header />
        <main>
          <Hero />
          <TrustStrip />
          <Services />
          <InspirationGallery />
          <Emotional />
          <WhyKindstone />
          <HowItWorks />
          <ServiceAreas />
          <FAQ />
          <QuoteForm />
        </main>
        <Footer />
        <StickyMobileCTA />
        <MetaPixelConsent />
      </div>
    </ErrorBoundary>
  );
};

export default App;
